import React from 'react';
import { Form, Row, Col, Card, Table } from 'react-bootstrap';

const AlcoholCalculator = () => {
  const [formData, setFormData] = React.useState({
    weddingGuests: 200,
    eventDuration: 4,
    champagneToast: 0,
    drinkingStyle: 1.0,
    beerPercentage: 0,
    winePercentage: 25,
    liquorPercentage: 75,
    redWinePercentage: 40,
    whiteWinePercentage: 40,
    roseSparklingPercentage: 20
  });

  const updateField = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const totalChampagneServings = formData.champagneToast === 1 ? formData.weddingGuests : 0;
  
  const totalDrinks = Math.round(formData.weddingGuests * formData.eventDuration * formData.drinkingStyle) - totalChampagneServings;
  const averageDrinksPerGuest = formData.weddingGuests > 0 ? Math.round((totalDrinks / formData.weddingGuests) * 10) / 10 : 0;

  const beerServings = Math.round(totalDrinks * (formData.beerPercentage / 100));
  const wineServings = Math.round(totalDrinks * (formData.winePercentage / 100));
  const liquorServings = Math.round(totalDrinks * (formData.liquorPercentage / 100));

  const redWineServings = Math.round(wineServings * (formData.redWinePercentage / 100));
  const whiteWineServings = Math.round(wineServings * (formData.whiteWinePercentage / 100));
  const roseSparklingServings = Math.round(wineServings * (formData.roseSparklingPercentage / 100));

  const champagneBottles = Math.ceil(totalChampagneServings / 6);
  const redWineBottles = Math.ceil(redWineServings / 5);
  const whiteWineBottles = Math.ceil(whiteWineServings / 5);
  const roseSparklingBottles = Math.ceil(roseSparklingServings / 5);
  const liquorBottles = Math.ceil(liquorServings / 19);
  const beerBottles = beerServings;

  const colaBottles = Math.ceil(liquorServings / 12 * 0.2);
  const dietColaBottles = Math.ceil(liquorServings / 12 * 0.2);
  const tonicBottles = Math.ceil(liquorServings / 12 * 0.1);
  const gingerAleBottles = Math.ceil(liquorServings / 12 * 0.2);
  const sodaWaterBottles = Math.ceil(liquorServings / 12 * 0.2);
  const juicesBottles = Math.ceil(liquorServings / 6 * 0.1);
  const waterBottles = Math.ceil(formData.weddingGuests * 2);

  return (
    <div className="alcohol-calculator">
      <Card>
        <Card.Header>
          <h3 className="mb-0">Your Wedding Details</h3>
        </Card.Header>
        <Card.Body>
          <p>To calculate how much wedding alcohol you'll need, start by entering your wedding guest count.</p>
          
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Number of Wedding Guests</strong></Form.Label>
                <Form.Control
                  type="number"
                  value={formData.weddingGuests}
                  onChange={(e) => updateField('weddingGuests', parseInt(e.target.value) || 0)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Event Duration (hours)</strong></Form.Label>
                <Form.Select
                  value={formData.eventDuration}
                  onChange={(e) => updateField('eventDuration', parseInt(e.target.value))}
                >
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                  <option value={6}>6</option>
                  <option value={7}>7</option>
                  <option value={8}>8</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Will There be a Champagne Toast?</strong></Form.Label>
                <Form.Select
                  value={formData.champagneToast}
                  onChange={(e) => updateField('champagneToast', parseInt(e.target.value))}
                >
                  <option value={0}>No</option>
                  <option value={1}>Yes</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Total Servings of Champagne</strong></Form.Label>
                <Form.Control
                  type="number"
                  value={totalChampagneServings}
                  readOnly
                  className="bg-light"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label><strong>Are your guests light, average or heavy drinkers?</strong></Form.Label>
            <Form.Select
              value={formData.drinkingStyle}
              onChange={(e) => updateField('drinkingStyle', parseFloat(e.target.value))}
            >
              <option value={0.85}>Light</option>
              <option value={1.0}>Average</option>
              <option value={1.15}>Heavy</option>
              <option value={1.30}>Extra Heavy</option>
            </Form.Select>
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Total Drinks (excluding Champagne)</strong></Form.Label>
                <Form.Control
                  type="number"
                  value={totalDrinks}
                  readOnly
                  className="bg-light"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Average Drinks Per Guest (excluding Champagne)</strong></Form.Label>
                <Form.Control
                  type="number"
                  step="0.1"
                  value={averageDrinksPerGuest}
                  readOnly
                  className="bg-light"
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-4">
        <Card.Header>
          <h4 className="mb-0">Alcohol Type Ratio</h4>
        </Card.Header>
        <Card.Body>
          <p>Allocate the % for each type of alcohol you'd like to serve—be sure it <strong>totals 100%</strong>. We've inserted the ratio for the typical wedding.</p>
          
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Beer</strong></Form.Label>
                <div className="input-group">
                  <Form.Control
                    type="number"
                    min="0"
                    max="100"
                    value={formData.beerPercentage}
                    onChange={(e) => updateField('beerPercentage', parseInt(e.target.value) || 0)}
                  />
                  <span className="input-group-text">%</span>
                </div>
                <div className="mt-1 text-muted">Beer Servings: {beerServings}</div>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Wine</strong></Form.Label>
                <div className="input-group">
                  <Form.Control
                    type="number"
                    min="0"
                    max="100"
                    value={formData.winePercentage}
                    onChange={(e) => updateField('winePercentage', parseInt(e.target.value) || 0)}
                  />
                  <span className="input-group-text">%</span>
                </div>
                <div className="mt-1 text-muted">Wine Servings: {wineServings}</div>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Liquor</strong></Form.Label>
                <div className="input-group">
                  <Form.Control
                    type="number"
                    min="0"
                    max="100"
                    value={formData.liquorPercentage}
                    onChange={(e) => updateField('liquorPercentage', parseInt(e.target.value) || 0)}
                  />
                  <span className="input-group-text">%</span>
                </div>
                <div className="mt-1 text-muted">Liquor Servings: {liquorServings}</div>
              </Form.Group>
            </Col>
          </Row>
          
          <div className={`alert ${(formData.beerPercentage + formData.winePercentage + formData.liquorPercentage) === 100 ? 'alert-info' : 'alert-danger'}`}>
            <strong>Total: {formData.beerPercentage + formData.winePercentage + formData.liquorPercentage}%</strong>
            {(formData.beerPercentage + formData.winePercentage + formData.liquorPercentage) !== 100 && (
              <span> - Should equal 100%</span>
            )}
          </div>
        </Card.Body>
      </Card>

      <Card className="mt-4">
        <Card.Header>
          <h4 className="mb-0">Wine Type Ratio</h4>
        </Card.Header>
        <Card.Body>
          <p>Allocate the % for each type of wine you'd like to serve—be sure it <strong>totals 100%</strong>. We've inserted the ratio for the typical wedding.</p>
          
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Red Wine</strong></Form.Label>
                <div className="input-group">
                  <Form.Control
                    type="number"
                    min="0"
                    max="100"
                    value={formData.redWinePercentage}
                    onChange={(e) => updateField('redWinePercentage', parseInt(e.target.value) || 0)}
                  />
                  <span className="input-group-text">%</span>
                </div>
                <div className="mt-1 text-muted">Red Wine Servings: {redWineServings}</div>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label><strong>White Wine</strong></Form.Label>
                <div className="input-group">
                  <Form.Control
                    type="number"
                    min="0"
                    max="100"
                    value={formData.whiteWinePercentage}
                    onChange={(e) => updateField('whiteWinePercentage', parseInt(e.target.value) || 0)}
                  />
                  <span className="input-group-text">%</span>
                </div>
                <div className="mt-1 text-muted">White Wine Servings: {whiteWineServings}</div>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Rosé / Sparkling</strong></Form.Label>
                <div className="input-group">
                  <Form.Control
                    type="number"
                    min="0"
                    max="100"
                    value={formData.roseSparklingPercentage}
                    onChange={(e) => updateField('roseSparklingPercentage', parseInt(e.target.value) || 0)}
                  />
                  <span className="input-group-text">%</span>
                </div>
                <div className="mt-1 text-muted">Rosé / Sparkling Servings: {roseSparklingServings}</div>
              </Form.Group>
            </Col>
          </Row>
          
          <div className={`alert ${(formData.redWinePercentage + formData.whiteWinePercentage + formData.roseSparklingPercentage) === 100 ? 'alert-info' : 'alert-danger'}`}>
            <strong>Total: {formData.redWinePercentage + formData.whiteWinePercentage + formData.roseSparklingPercentage}%</strong>
            {(formData.redWinePercentage + formData.whiteWinePercentage + formData.roseSparklingPercentage) !== 100 && (
              <span> - Should equal 100%</span>
            )}
          </div>
        </Card.Body>
      </Card>

      <Card className="mt-4">
        <Card.Header>
          <h4 className="mb-0">Your Shopping List</h4>
        </Card.Header>
        <Card.Body>
          <p>Here are our recommended quantities of alcohol and mixers.</p>
          
          <Row>
            <Col md={6}>
              <h5>Alcohol</h5>
              <Table striped bordered size="sm">
                <tbody>
                  <tr>
                    <td><strong>Champagne (750 ml bottles)</strong><br/><small>Each bottle has 6 servings</small></td>
                    <td className="text-center">{champagneBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>Red Wine (750 ml bottles)</strong><br/><small>Each bottle has 5 servings</small></td>
                    <td className="text-center">{redWineBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>White Wine (750 ml bottles)</strong><br/><small>Each bottle has 5 servings</small></td>
                    <td className="text-center">{whiteWineBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>Rosé and/or Sparkling Wine (750 ml bottles)</strong><br/><small>Each bottle has 5 servings</small></td>
                    <td className="text-center">{roseSparklingBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>Liquor (1 liter bottles)</strong><br/><small>Each bottle has 19 servings</small></td>
                    <td className="text-center">{liquorBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>Beer (cans or bottles)</strong><br/><small>Each bottle has 1 serving</small></td>
                    <td className="text-center">{beerBottles}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col md={6}>
              <h5>Mixers</h5>
              <Table striped bordered size="sm">
                <tbody>
                  <tr>
                    <td><strong>Cola (2 liter)</strong><br/><small>Each bottle has 12 servings</small></td>
                    <td className="text-center">{colaBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>Diet Cola (2 liter)</strong><br/><small>Each bottle has 12 servings</small></td>
                    <td className="text-center">{dietColaBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>Tonic (2 liter)</strong><br/><small>Each bottle has 12 servings</small></td>
                    <td className="text-center">{tonicBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>Ginger Ale (2 liter)</strong><br/><small>Each bottle has 12 servings</small></td>
                    <td className="text-center">{gingerAleBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>Soda Water (2 liter)</strong><br/><small>Each bottle has 12 servings</small></td>
                    <td className="text-center">{sodaWaterBottles}</td>
                  </tr>
                  <tr>
                    <td><strong>Juices (1 liter)</strong><br/><small>Each bottle has 6 servings</small></td>
                    <td className="text-center">{juicesBottles}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          
          <Row className="mt-4">
            <Col md={12}>
              <h5>Water</h5>
              <Table striped bordered size="sm">
                <tbody>
                  <tr>
                    <td><strong>Water (bottles)</strong><br/><small>Each bottle has 1 serving</small></td>
                    <td className="text-center">{waterBottles}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AlcoholCalculator;
